import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { fetchActiveTournamentPlan, givePlan, topupBalance } from './actions';
import { OrganizersSliceState } from './index';

type ReducerBuilder = ActionReducerMapBuilder<OrganizersSliceState>;

export function createFetchActiveTournamentPlanReducer(builder: ReducerBuilder) {
  builder.addCase(fetchActiveTournamentPlan.pending, (state) => {
    state.isProcessing = true;
    state.isProcessed = false;
    state.processName = 'fetchActiveTournamentPlan';
  });

  builder.addCase(fetchActiveTournamentPlan.fulfilled, (state, action) => {
    state.plans.byOwnerId[action.meta.arg.tournamentId] = action.payload;
    state.isProcessing = false;
    state.isProcessed = true;
  });

  builder.addCase(fetchActiveTournamentPlan.rejected, (state) => {
    toast.error('Не удалось получить активный план');
  });
}

// Баланс после пополнения и после выдачи плана перечитывается из RTK Query:
// вызывающий код инвалидирует тег 'Organizer' (balance.tsx, plans-block.tsx).
export function createTopupBalanceReducer(builder: ReducerBuilder) {
  builder.addCase(topupBalance.pending, (state) => {
    state.isProcessing = true;
    state.isProcessed = false;
    state.processName = 'topupBalance';
  });

  builder.addCase(topupBalance.fulfilled, (state, action) => {
    state.isProcessing = false;
    state.isProcessed = true;
    state.processName = undefined;

    toast.success(`Баланс успешно пополнен на сумму ${action.meta.arg.amount} руб.!`);
  });

  builder.addCase(topupBalance.rejected, (state) => {
    state.isProcessing = false;
    state.isProcessed = false;
    toast.error('Не удалось пополнить баланс');
  });
}

export function createGivePlanReducer(builder: ReducerBuilder) {
  builder.addCase(givePlan.pending, (state) => {
    state.isProcessing = true;
    state.isProcessed = false;
    state.processName = 'givePlan';
  });

  builder.addCase(givePlan.fulfilled, (state) => {
    state.isProcessing = false;
    state.isProcessed = true;
    state.processName = undefined;

    toast.success('План подключен');
  });

  builder.addCase(givePlan.rejected, (state) => {
    state.isProcessing = false;
    state.isProcessed = false;
    toast.error('Не удалось выдать план');
  });
}
